// @flow
'use strict';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';

import { rootSelector, aplicaFiltro } from '../../../../reducers/nfse/filtro_estruturado';

import ModalBuscaEstruturada from './modal_busca_estruturada';

const mapStateToProps = createStructuredSelector({ initialValues: rootSelector });

export default compose(
    connect<*, *, *, *, *, *>(mapStateToProps),
    reduxForm({
      form: 'nfseFiltroEstruturado', enableReinitialize: true,
      onSubmit(form, dispatch) {
        dispatch(aplicaFiltro(form));
      },
    }),
)(ModalBuscaEstruturada);
